import { Box, Stack } from "@mui/material";
import React from "react";
import { Outlet, useLocation } from "react-router-dom";

export default function AuthLayout() {
  const location = useLocation().pathname
  return (
    <Stack sx={{ position: "relative" }}>
      <Outlet />
      <Box
        sx={{
          position: "absolute",
          bottom: location == "/auth/verify" ? "20%" : "60%",
          left: location == "/auth/verify" ? "23%" : "65%",
          // transform: "translate(-40% , 70%)",
          zIndex: "-10",
          width: "270px",
          height: "270px",
          opacity: ".7",
          transition:"all .5s ease"
        }}
      >
        <img
          style={{ width: "100%", height: "100%" }}
          src="/Media/Circles/circle.svg"
          alt="circle images"
        />
      </Box>
    </Stack>
  );
}
